module.exports = __webpack_public_path__ + "6c1b37c5db261085b5b0b74d00eb80c3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/blue_eradicated.png
 ** module id = 997
 ** module chunks = 0
 **/